<div class="modal-content">
  <div class="modal-header d-flex justify-content-between align-items-center mb-2">
    <h4 class="mb-0">Route Preview</h4>
    <mat-icon style="cursor: pointer;" (click)="close()">close</mat-icon>
  </div>
  
  <div class="layout-container">
    <div class="map-container">
      <div id="route-preview-map"></div>
    </div>
    
    <!-- Waypoints Editor Sidebar -->
    <div class="waypoints-panel">
      <div class="panel-header">
        <mat-icon>navigation</mat-icon>
        <h3>Route Waypoints</h3>
      </div>
      
      <div class="toggle-section" style="padding: 10px; background: rgba(0,0,0,0.1); border-bottom: 1px solid rgba(255,255,255,0.05);">
        <div class="toggle-group">
            <span class="toggle-label">Show Distances</span>
            <label class="switch">
                <input type="checkbox" [checked]="showDistances" (change)="showDistances = $any($event.target).checked; drawAllLegs(false)">
                <span class="slider"></span>
            </label>
        </div>
        <div class="toggle-group">
            <span class="toggle-label">Show Course</span>
            <label class="switch">
                <input type="checkbox" [checked]="showCourse" (change)="showCourse = $any($event.target).checked; drawAllLegs(false)">
                <span class="slider"></span>
            </label>
        </div>
      </div>
      
      <div class="panel-body">
        <div class="leg-section" *ngFor="let leg of legDataArray; let i = index">
          <h4>{{ leg.legName }}</h4>
          
          <div class="waypoint-wrapper" *ngFor="let wp of leg.waypoints; let w = index">
            <div class="waypoint-card" 
                 id="wp-card-{{i}}-{{w}}"
                 [ngClass]="wp.isNoon ? 'fixed-noon' : 'added-wp'">
              
              <div class="card-header">
                <span class="wp-title">
                  [#{{ w + 1 }}] {{ wp.isNoon ? 'Actual Position (Noon)' : 'Derived Waypoint' }}
                  <span *ngIf="wp.isLocked" style="font-size: 0.8em; color: #f87171; margin-left: 5px;">🔒 Locked</span>
                </span>
                <button class="btn-delete" *ngIf="!wp.isNoon && !wp.isLocked" (click)="leg.waypoints.splice(w, 1); updateLegLocally(i); drawAllLegs(false)" title="Delete waypoint">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              
              <div class="inputs-row">
                <div class="input-group">
                  <label>Latitude</label>
                  <input type="number" step="0.0001" [value]="wp.lat" (change)="wp.lat = $any($event.target).valueAsNumber; updateLegLocally(i)" [disabled]="wp.isNoon || wp.isLocked" />
                </div>
                <div class="input-group">
                  <label>Longitude</label>
                  <input type="number" step="0.0001" [value]="wp.lon" (change)="wp.lon = $any($event.target).valueAsNumber; updateLegLocally(i)" [disabled]="wp.isNoon || wp.isLocked" />
                </div>
              </div>
            </div>

            <!-- Add button between waypoints -->
            <div class="add-wp-divider" *ngIf="w < leg.waypoints.length - 1 && !(leg.waypoints[w].isLocked && leg.waypoints[w+1].isLocked)">
              <div class="line"></div>
              <button class="btn-add-mid" (click)="addWaypointBetween(i, w)" title="Add middle point">
                <mat-icon>add</mat-icon>
              </button>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="text-center mt-3" style="display: flex; justify-content: center; align-items: center; gap: 15px;">
    <span *ngIf="isRecalculating" class="text-warning"><mat-icon inline="true">hourglass_empty</mat-icon> Recalculating route...</span>
    
    <button class="btn-secondary" style="background: transparent; border: 1px solid #4a4a5a; padding: 8px 16px; border-radius: 4px; color: white; cursor: pointer;" (click)="close()">Close</button>
  </div>

  <button class="btn-primary" *ngIf="hasEditableWaypoints()"
          style="background: #3b82f6; border: none; padding: 12px 24px; border-radius: 30px; color: white; cursor: pointer; position: fixed; bottom: 40px; right: 40px; z-index: 1000; box-shadow: 0 4px 15px rgba(0,0,0,0.5); display: flex; align-items: center; font-weight: bold; font-size: 16px;" 
          (click)="saveAll()" [disabled]="isSaving || isRecalculating">
    <mat-icon style="margin-right: 8px;">save</mat-icon>
    {{ isSaving ? 'Saving...' : 'Save' }}
  </button>
</div>
